"use strict";var inherit = require("raptor-util/inherit");
var VNode = require("./VNode");

function VComponent(component, key, ownerComponent, preserve) {
  this.bU_(null /* childCount */, ownerComponent);
  this.bV_ = key;
  this.s_ = component;
  this.ac_ = preserve;
}

VComponent.prototype = {
  bW_: 2
};

inherit(VComponent, VNode);

module.exports = VComponent;